import FetchService from "./Shared/FetchService";
const AVISO_LOG_LEVELS = {
    trace: "TRACE",
    debug: "DEBUG",
    info: "INFO",
    warn: "WARN",
    error: "ERROR",
    fatal: "FATAL",
};
/**
 * Log service
 *
 * @example
 * AvisoExternalLogService.trace("message", "details");
 *
 * Details are optional.
 * Available methods are trace, debug, info, warn, error, fatal.
 */
const AvisoLogService = Object.keys(AVISO_LOG_LEVELS).reduce((service, level) => {
    return Object.assign(Object.assign({}, service), { [level]: (message, detail = "") => FetchService.postSingleResponse("/aviso/internalLog/write", {
            message,
            detail,
            level: AVISO_LOG_LEVELS[level],
        }) });
}, {});
export default AvisoLogService;
